import { render, staticRenderFns } from "./ReportPage.vue?vue&type=template&id=21344696&scoped=true&"
import script from "./ReportPage.vue?vue&type=script&lang=ts&"
export * from "./ReportPage.vue?vue&type=script&lang=ts&"
import style0 from "./ReportPage.vue?vue&type=style&index=0&id=21344696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21344696",
  null
  
)

export default component.exports